import Button from '../Button/Button';
import './CallToAction.scss';
import classNames from 'classnames';

export default function CallToAction({
	children,
	'action-text': actionText,
	'action-url': actionUrl,
}) {
	return (
		<div className="call-to-action">
			<div className="text">{children}</div>
			<div className="action">
				<Button
					href={actionUrl}
					className={classNames(['btn', 'btn-lg'])}
					sfx="rising-pops"
				>
					{actionText}
				</Button>
			</div>
		</div>
	);
}
